import styled from "@emotion/styled";
import { Colors, Fonts, Spacing } from "@snapchat/snap-design-system";

export const ClosableModalHeader = styled.div`
    ${Fonts.Heading.H500};
    margin-bottom: ${Spacing.SM}px;
    line-height: 22px;
`;

export const ClosableModalBody = styled.div`
    min-height: 200px;
    border-top: 1px solid ${Colors.Gray.V50};
`;
